var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_37014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2388 13.0253C19.8333 13.3693 20.267 13.935 20.4449 14.5984C20.6228 15.2617 20.5303 15.9686 20.1876 16.5638L12.2922 30.5017C11.9484 31.0963 11.3827 31.5303 10.7193 31.7082C10.0558 31.8861 9.34889 31.7934 8.75372 31.4505C8.15908 31.1067 7.72511 30.5411 7.54704 29.8777C7.36898 29.2143 7.46136 28.5074 7.80391 27.9121L15.6956 13.9742C15.866 13.6792 16.0927 13.4207 16.3629 13.2133C16.6332 13.006 16.9416 12.8539 17.2707 12.7658C17.5997 12.6777 17.9428 12.6553 18.2805 12.6998C18.6182 12.7443 18.9438 12.8549 19.2388 13.0253Z",
    fill: "url(#paint0_linear_15_37014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51697 14.4091C5.51697 14.0685 5.58405 13.7313 5.71437 13.4166C5.8447 13.102 6.03572 12.8161 6.27654 12.5753C6.51735 12.3345 6.80323 12.1435 7.11787 12.0131C7.43251 11.8828 7.76974 11.8157 8.1103 11.8157H25.3482C25.8015 11.8157 26.2468 11.9345 26.6397 12.1603C27.0327 12.3861 27.3596 12.711 27.5877 13.1026C27.8175 13.4966 27.9393 13.9443 27.9408 14.4004C27.9424 14.8565 27.8235 15.305 27.5964 15.7005C27.3693 16.096 27.0418 16.4247 26.6471 16.6533C26.2524 16.8818 25.8044 17.0023 25.3482 17.0024H8.1103C7.76974 17.0024 7.43251 16.9353 7.11787 16.805C6.80323 16.6747 6.51735 16.4836 6.27654 16.2428C6.03572 16.002 5.8447 15.7161 5.71437 15.4015C5.58405 15.0868 5.51697 14.7496 5.51697 14.4091Z",
    fill: "url(#paint1_linear_15_37014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4925 1.89605e-06C13.9524 -0.000552612 14.4042 0.120529 14.8022 0.350964C15.2001 0.581399 15.5301 0.912989 15.7585 1.3121C15.9869 1.71121 16.1058 2.16363 16.1029 2.62349C16.1 3.08334 15.9756 3.53426 15.7422 3.9305L4.87074 21.6489C4.64055 22.0422 4.31131 22.3683 3.91584 22.5946C3.52038 22.821 3.07249 22.9398 2.61681 22.9391C2.16114 22.9384 1.7136 22.8184 1.31879 22.5909C0.923975 22.3633 0.595686 22.0363 0.366634 21.6424L0.358254 21.6285C0.123668 21.2285 0 20.7731 0 20.3094C0 19.8457 0.123668 19.3904 0.358254 18.9904L11.2428 1.28596C11.4731 0.894101 11.8019 0.569277 12.1966 0.343703C12.5912 0.11813 13.038 -0.000354882 13.4925 1.89605e-06Z",
    fill: "url(#paint2_linear_15_37014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3148 0.00839895C25.7677 0.011097 26.212 0.132149 26.6037 0.359551C26.9954 0.586953 27.3208 0.912803 27.5477 1.30478C27.7746 1.69676 27.8951 2.14124 27.8972 2.59415C27.8994 3.04707 27.783 3.49266 27.5598 3.88675L24.5801 9.16373C24.3488 9.57335 24.0106 9.91241 23.6015 10.1447C23.1924 10.3769 22.728 10.4936 22.2577 10.4823H22.1646C21.712 10.4727 21.2698 10.345 20.8817 10.1118C20.4937 9.87863 20.1734 9.54807 19.9525 9.15291C19.7317 8.75775 19.6179 8.31172 19.6226 7.85905C19.6272 7.40638 19.7501 6.96279 19.9791 6.57227L23.052 1.29715C23.2824 0.902219 23.613 0.57509 24.0103 0.348807C24.4076 0.122523 24.8575 0.00509987 25.3148 0.00839895Z",
    fill: "url(#paint3_linear_15_37014)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_37014",
    x1: 3.78681,
    y1: 4.69968,
    x2: 19.0525,
    y2: 30.9272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E80089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#AD00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6200EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#05D1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_37014",
    x1: 8.70532,
    y1: 0.619264,
    x2: 25.1462,
    y2: 28.8665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E80089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#AD00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6200EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#05D1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15_37014",
    x1: 3.41531,
    y1: 3.49471,
    x2: 21.7623,
    y2: 35.0169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E80089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#AD00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6200EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#05D1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15_37014",
    x1: 17.9408,
    y1: -4.7555,
    x2: 34.3816,
    y2: 23.4918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E80089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#AD00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6200EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#05D1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_37014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9408,
    height: 31.7966,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo-new.298a1b7c.svg";
export { ForwardRef as ReactComponent };